// extracted by mini-css-extract-plugin
export default {"sizes":"o8hC4","column":"zmMUe","size":"GHJwi","sizeX":"E2KeJ","title":"H9hFX","value":"vvvTR"};